import _Number$parseFloat from "babel-runtime/core-js/number/parse-float";
import { parseAddress } from "../../tools/util";
import date from "../../tools/date";
import * as utils from "@/tools/util";
var validateRules = {
  "email": {
    valid: function valid(value, param) {
      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      var len = change2star(value).length;
      if (param && param.length == 1) {
        return len <= param[0] && /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
      } else if (param && param.length == 2) {
        return len >= param[0] && len <= param[1] && /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
      } else {
        return (/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value)
        );
      }
    },
    msg: "请输入正确的邮箱地址"
  },
  "mobile": {
    valid: function valid(value) {
      return (/^([+]?[\d]{1,3}-|[ ])?((13[0-9]{9})|(18[0-9]{9})|(15[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(16[0-9]{9})|(19[0-9]{9}))$/.exec(value)
      );
    },
    limitLength: 11,
    msg: "请输入正确的手机号码"
  },
  "tel": {
    valid: function valid(value) {
      return (/^(([0\+]\d{2,3}-?)?(0\d{2,3})-?)?(\d{7,8})(-(\d{1,}))?$/.test(value)
      );
    },
    msg: "请输入正确的电话号码"
  },
  "numchar": {
    valid: function valid(value, param) {
      function isnumchar(s) {
        var regularExpression = /^([\w])+$/;
        return regularExpression.test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (isnumchar(value)) {
        var len = change2star(value).length;
        if (param.length == 1) {
          return len == param[0];
        } else {
          if (param[0] === param[1]) {
            this.msg = "请输入{0}位长度的数字或英文字符";
          }
          return len >= param[0] && len <= param[1];
        }
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,只能输入数字或英文字符"
  },
  "number": {
    valid: function valid(value, param) {
      param = param != undefined ? param : [100, 10];

      var value = _.trim(value);

      function isnumber(s, p1, p2) {
        var regularExpression = "/^(-)?(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$/";
        return eval(regularExpression).test(s);
      }

      function isnumber2(s, p1) {
        var regularExpression = "/^(-)?(\\d){1," + parseInt(p1) + "}$/";
        return eval(regularExpression).test(s);
      }

      if (param && 1 === param.length) {
        this.msg = "请输入正确的数字，整数位最多{0}位";
      } else if (param && 2 === param.length) {
        this.msg = "请输入正确的数字，整数位最多{0}位，小数位最多{1}位";
      }

      var flag = value.indexOf(".") != -1 ? isnumber(value, param[0], param[1]) : isnumber2(value, param[0]);
      if (!flag) {
        return false;
      } else if (value.indexOf(".") == value.length - 1) {
        return false;
      } else {
        return true;
      }
    },
    msg: "请输入正确的数字"
  },

  "numberex": {
    valid: function valid(value, param) {
      this.msg = getMessage(param);
      var value = _.trim(value);

      function isnumber(s, p0, p1, p2) {
        if (p0 == "0" || !p0) {
          var regularExpression = "^(-)?(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
              regularExpression2 = "^(-)?(\\d){1," + parseFloat(p1) + "}$";
          return new RegExp(regularExpression).test(s) || new RegExp(regularExpression2).test(s);
        } else if (p0 == "10") {
          var regularExpression = "^(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
              regularExpression2 = "^(\\d){1," + parseFloat(p1) + "}$";
          return new RegExp(regularExpression).test(s) || new RegExp(regularExpression2).test(s);
        } else if (p0 == "-10") {
          var regularExpression = "^(-)(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
              regularExpression2 = "^(-)(\\d){1," + parseFloat(p1) + "}$";
          return new RegExp(regularExpression).test(s) || new RegExp(regularExpression2).test(s);
        } else if (p0 == "1") {
          var regularExpression = "^(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
              regularExpression2 = "^(\\d){1," + parseFloat(p1) + "}$";
          return (new RegExp(regularExpression).test(s) || new RegExp(regularExpression2).test(s)) && Number(s) > 0;
        } else if (p0 == "-1") {
          var regularExpression = "^(-)(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){1," + parseFloat(p2) + "}$",
              regularExpression2 = "^(-)(\\d){1," + parseFloat(p1) + "}$";
          return (new RegExp(regularExpression).test(s) || new RegExp(regularExpression2).test(s)) && Number(s) < 0;
        } else if (p0 == "2") {
          if (value < 1 && value >= 0) {
            var regularExpression = "^(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$";
            return new RegExp(regularExpression).test(s);
          } else {
            return false;
          }
        } else if (p0 == "3") {
          if (value <= 1 && value > 0) {
            var regularExpression = "^(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
                regularExpression2 = "^(\\d){1," + parseFloat(p1) + "}$";
            return (new RegExp(regularExpression).test(s) || new RegExp(regularExpression2).test(s)) && Number(s) > 0;
          } else {
            return false;
          }
        } else if (p0 == "4") {
          if (value < 1 && value > 0) {
            var regularExpression = "^(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$";
            return new RegExp(regularExpression).test(s);
          } else {
            return false;
          }
        } else if (p0 == "5") {
          if (value <= 1 && value >= 0) {
            var regularExpression = "^(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$";
            return new RegExp(regularExpression).test(s);
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      function isnumber2(s, p0, p1) {
        if (p0 == "0" || !p0) {
          var regularExpression = "/^(-)?(\\d){1," + parseInt(p1) + "}$/";
          return eval(regularExpression).test(s);
        } else if (p0 == "10") {
          var regularExpression = "/^(\\d){1," + parseInt(p1) + "}$/";
          return eval(regularExpression).test(s);
        } else if (p0 == "-10") {
          var regularExpression = "/(^0$)|(^(-)(\\d){1," + parseInt(p1) + "}$)/";
          return eval(regularExpression).test(s);
        } else if (p0 == "1") {
          var regularExpression = "/^[1-9](\\d){0," + (parseInt(p1) - 1) + "}$/";
          return eval(regularExpression).test(s);
        } else if (p0 == "-1") {
          var regularExpression = "/^(-)[1-9](\\d){1," + (parseInt(p1) - 1) + "}$/";
          return eval(regularExpression).test(s);
        } else if (p0 == "2") {
          if (value < 1 && value >= 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      function getMessage(param) {
        if (2 === param.length) {
          return "0" == param[0] ? "请输入正确的整数，最多{1}位" : "10" == param[0] ? "请输入大于等于0的整数，最多{1}位" : "-10" == param[0] ? "请输入小于等于0的整数，最多{1}位" : "1" == param[0] ? "请输入正确的正整数，最多{1}位" : "-1" == param[0] ? "请输入正确的负整数，最多{1}位" : "2" == param[0] ? "请输入大于0且小于1的数字" : "请输入正确的数字";
        } else if (3 === param.length) {
          return "0" == param[0] ? "请输入正确的数字，小数点前最多{1}位，小数点后最多{2}位" : "10" == param[0] && "0" == param[2] ? "请输入正整数" : "10" == param[0] ? "请输入大于等于0的数字，小数点前最多{1}位，小数点后最多{2}位" : "-10" == param[0] ? "请输入小于等于0的数字，小数点前最多{1}位，小数点后最多{2}位" : "1" == param[0] ? "请输入大于0的数字，小数点前最多{1}位，小数点后最多{2}位" : "-1" == param[0] ? "请输入小于0的数字，小数点前最多{1}位，小数点后最多{2}位" : "2" == param[0] ? "请输入大于等于0且小于1的数字，小数点前最多{1}位，小数点后最多{2}位" : "3" == param[0] ? "请输入大于0且小于等于1的数字，小数点前最多{1}位，小数点后最多{2}位" : "4" == param[0] ? "请输入大于0且小于1的数字，小数点前最多{1}位，小数点后最多{2}位" : "5" == param[0] ? "请输入大于等于0且小于等于1的数字，小数点前最多{1}位，小数点后最多{2}位" : "请输入正确的数字";
        } else if (4 === param.length) {
          return "0" == param[3] ? "请输入正确的金额，最大为整数{1}位，小数{2}位" : "1" == param[3] ? "请输入正确的金额，小数点后保留{2}位" : "请输入正确的金额";
        }

        return "请输入正确的数字";
      }

      if (!/^(\+|-)?(\d+)(,\d{3})*(\.\d+)?$/.test(value)) {
        return false;
      } else {
        if (value.indexOf(",") > 0) value = value.replace(/,/g, "");
      }

      var flag = param.length > 2 ? isnumber(value, param[0], param[1], param[2] || 0) : isnumber2(value, param[0], param[1]);

      if (!flag) {
        return false;
      } else if (value.indexOf(".") == value.length - 1) {
        return false;
      } else {
        return true;
      }
    },
    msg: "请输入正确的数字"
  },
  "money": {
    valid: function valid(value, param) {
      param = param != undefined ? param : [20, 10];

      var value = _.trim(value);

      function isnumber(s, p1, p2) {
        var regularExpression = "/^(-)?(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$/";
        return eval(regularExpression).test(s);
      }

      function isnumber2(s, p1) {
        var regularExpression = "/^(-)?[1-9](\\d){0," + (parseInt(p1) - 1) + "}$/";
        return eval(regularExpression).test(s);
      }

      var flag = value.indexOf(".") != -1 ? isnumber(value, param[0], param[1]) : isnumber2(value, param[0]);
      if (!flag) {
        return false;
      } else if (value.indexOf(".") == value.length - 1) {
        return false;
      } else {
        return true;
      }
    },
    msg: "请输入正确的金额"
  },
  "zmoney": {
    valid: function valid(value, param) {
      param = param != undefined ? param : [20, 10];

      var value = _.trim(value);

      function isnumber(s, p1, p2) {
        var regularExpression = "/^(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$/";
        return eval(regularExpression).test(s);
      }

      function isnumber2(s, p1) {
        var regularExpression = "/^[1-9](\\d){0," + (parseInt(p1) - 1) + "}$/";
        return eval(regularExpression).test(s);
      }

      var flag = value.indexOf(".") != -1 ? isnumber(value, param[0], param[1]) : isnumber2(value, param[0]);
      if (!flag) {
        return false;
      } else if (value.indexOf(".") == value.length - 1) {
        return false;
      } else {
        return true;
      }
    },
    msg: "请输入不为负数的正确金额"
  },
  "int": {
    valid: function valid(value, param) {
      if (value.indexOf(",") > 0) value = value.replace(/,/g, "");

      function isint(s) {
        var regularExpression = /^(-)?\d*$/;

        return regularExpression.test(s);
      }

      if (isint(value)) {
        var len = value.length;
        if (param && len > param[0]) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    msg: "请输入正确的整数"
  },

  "zint": {
    valid: function valid(value, param) {
      this.msg = param[2] || "请输入正确的正整数,最大{0}位";

      if (value.indexOf(",") > 0) value = value.replace(/,/g, "");

      function iszint(s) {
        var regularExpression = /^[0-9]\d*$/;
        return regularExpression.test(s);
      }

      if (iszint(value)) {
        var len = value.length;

        if (param[1] == "1" && parseInt(value) == "0") {
          this.msg = param[2] || "请输入正确的正整数";
          return false;
        }
        if (len > param[0]) {
          ;
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    msg: "请输入正确的正整数,最大{0}位"
  },

  "num": {
    valid: function valid(value, param) {
      function isnum(s, data) {
        var regularExpression = "/^(\\d){" + parseFloat(data) + "}$/";
        return eval(regularExpression).test(s);
      }

      function isnum1(s, data) {
        var regularExpression = "/^(\\d){" + parseFloat(param[0]) + "," + parseFloat(param[1]) + "}$/";
        return eval(regularExpression).test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (param.length == 1) {
        if (isnum(value, param[0])) {
          var itemValue = change2star(value);
          if (itemValue.length >= param[0]) {
            return true;
          } else {
            this.msg = "请输入{0}位数字";
            return false;
          }
        } else {
          this.msg = "请输入{0}位数字";
          return false;
        }
      } else {
        var itemValue = change2star(value);
        if (isnum1(value, param[0])) {
          if (itemValue.length >= param[0] && itemValue.length <= param[1]) {
            return true;
          } else {
            this.msg = "请输入{0} 到 {1}位数字";
            return false;
          }
        } else {
          this.msg = "请输入{0} 到 {1}位数字";
          return false;
        }
      }
    },
    msg: "请输入{0}位数字"
  },
  "numberLength": {
    valid: function valid(value, param) {
      function isnum(s, data) {
        var regularExpression = "/^(\\d){" + parseFloat(data) + "}$/";
        return eval(regularExpression).test(s);
      }

      function isnum1(s, data) {
        var regularExpression = "/^(\\d){" + parseFloat(param[0]) + "," + parseFloat(param[1]) + "}$/";
        return eval(regularExpression).test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (param.length == 1) {
        if (isnum(value, param[0])) {
          var itemValue = change2star(value);
          if (itemValue.length >= param[0]) {
            return true;
          } else {
            this.msg = "请输入{0}位数字";
            return false;
          }
        } else {
          this.msg = "请输入{0}位数字";
          return false;
        }
      } else {
        var itemValue = change2star(value);
        if (isnum1(value, param[0])) {
          if (itemValue.length >= param[0] && itemValue.length <= param[1]) {
            return true;
          } else {
            this.msg = "请输入{0} 到 {1}位数字";
            return false;
          }
        } else {
          this.msg = "请输入{0} 到 {1}位数字";
          return false;
        }
      }
    },
    msg: "请输入{0}位数字"
  },
  "postcode": {
    valid: function valid(value) {
      var value = _.trim(value);

      function ispostcode(s) {
        var patrn = /^[0-9]\d{3,7}$/;
        if (!patrn.exec(s)) {
          return false;
        }
        return true;
      }

      if (ispostcode(value)) {
        return true;
      } else {
        return false;
      }
    },
    msg: "请输入正确的邮政编码"
  },
  "agesInit": {
    valid: function valid(value) {
      var ages = utils.getAge(value);
      if (ages >= 18) {
        return true;
      }
    },
    msg: "年龄必须大于18周岁"
  },
  "cardno": {
    valid: function valid(value, isLen18) {
      var value = _.trim(value);

      function iscardno(s) {
        var area = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外"
        };
        var idcard = s,
            Y = void 0,
            JYM = void 0;
        var SS = void 0,
            M = void 0;
        var idcard_array = new Array();
        idcard_array = idcard.split("");

        if (area[parseInt(idcard.substr(0, 2))] == null) {
          return false;
        }

        var ereg = void 0;
        switch (idcard.length) {
          case 15:
            if (isLen18 && isLen18[0]) {
              return false;
            }
            if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || (parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0) {
              ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;
            } else {
              ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;
            }
            if (ereg.test(idcard)) {
              return true;
            } else {
              return false;
            }
          case 18:
            if (parseInt(idcard.substr(6, 4)) % 4 == 0 || parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0) {
              ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;
            } else {
              ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;
            }

            if (ereg.test(idcard)) {
              SS = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) * 1 + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
              Y = SS % 11;
              M = "F";
              JYM = "10X98765432";
              M = JYM.substr(Y, 1);
              if (M == idcard_array[17]) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          default:
            return false;
        }
      }

      if (iscardno(value)) {
        return true;
      } else {
        return false;
      }
    },
    msg: "请输入正确的身份证号"
  },
  "ABCcardno": {
    valid: function valid(value, isLen18) {
      var value = _.trim(value);

      function iscardno(s) {
        var area = {
          83: "台湾",
          81: "香港",
          82: "澳门"
        };
        var idcard = s,
            Y = void 0,
            JYM = void 0;
        var SS = void 0,
            M = void 0;
        var idcard_array = new Array();
        idcard_array = idcard.split("");

        if (area[parseInt(idcard.substr(0, 2))] == null) {
          return false;
        }

        var ereg = void 0;
        switch (idcard.length) {
          case 15:
            if (isLen18 && isLen18[0]) {
              return false;
            }
            if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || (parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0) {
              ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;
            } else {
              ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;
            }
            if (ereg.test(idcard)) {
              return true;
            } else {
              return false;
            }
          case 18:
            if (parseInt(idcard.substr(6, 4)) % 4 == 0 || parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0) {
              ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;
            } else {
              ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;
            }

            if (ereg.test(idcard)) {
              SS = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) * 1 + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
              Y = SS % 11;
              M = "F";
              JYM = "10X98765432";
              M = JYM.substr(Y, 1);
              if (M == idcard_array[17]) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          default:
            return false;
        }
      }

      if (iscardno(value)) {
        return true;
      } else {
        return false;
      }
    },
    msg: "请输入正确的居住证号码"
  },
  "orgcode": {
    valid: function valid(value) {
      var regularExpression = /^[1-9]\d*$/;
      if (regularExpression.test(value) && value < 32767) {
        return true;
      }
      return false;
    },
    msg: ""
  },
  "cnchar": {
    valid: function valid(value) {
      return (/^[\u4e00-\u9fa5]+$/.test(value)
      );
    },
    msg: "只能输入中文字符"
  },

  "en_ch": {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression = /[^\u4e00-\u9fa5a-zA-Z\-\_\.]+/;
        return !regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,只能输入中文或英文且不能输入特殊字符"
  },
  "name": {
    valid: function valid(value) {
      return (/^((([\u4e00-\u9fa5a-zA-Z\-\_\.\s])+)·?)+$/.test(value)
      );
    },
    msg: "请输入正确的姓名"
  },
  "cnname": {
    valid: function valid(value) {
      return (/^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+){0,3}[\u4e00-\u9fa5]$/.test(value)
      );
    },
    msg: "请输入正确的中文姓名"
  },
  "length": {
    valid: function valid(value) {
      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      var len = change2star(value).length;

      return len >= param[0] && len <= param[1];
    },
    msg: "请输入 {0} 到 {1} 个字符，1个中文算2个字符"
  },
  "address": {
    valid: function valid(value, isChinaAddress) {
      function checkunval(t) {
        var regularExpression = /^[^@。，、,？?【】《》<>：；\[\]{}!！+=~|\/\'\\\"$%&\^\*]+$/;
        return regularExpression.test(t);
      }

      return checkunval(value);
    },
    msg: "请输入正确地址,且不能输入除（‘#’、‘-’、‘.’、‘（）’）以外的特殊字符"
  },
  "addrLength": {
    valid: function valid() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 120];

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**").length;
      }

      var result = change2star(val);
      return result > len[0] && result < len[1];
    },

    msg: "详细地址长度应该在{0} 到 {1}字符之间，中文算两个字符"
  },

  "numCharMinus": {
    valid: function valid(value, param) {
      function isNumcharMinus(s) {
        var regularExpression = /^([\w\-])+$/;
        return regularExpression.test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (isNumcharMinus(value)) {
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,只能输入数字或英文字符或者'-'"
  },
  "tel1": {
    valid: function valid(value) {
      return (/^([0\+]\d{2,3})$/.test(value)
      );
    },
    msg: "请输入正确的国际编号"
  },
  "tel2": {
    valid: function valid(value) {
      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      var len = change2star(value).length;
      return len >= 3 && len <= 5;
    },
    msg: "请输入 3 到 5 位数字的区号"
  },
  "tel3": {
    valid: function valid(value, telPhoneType) {
      if (telPhoneType == 1) {
        this.msg = "请输入正确的电话号码";
        return (/^(([0\+]\d{2,4}-?)?(0\d{2,4})-?)?(\d{7,8})(-(\d{1,}))?$/.exec(value)
        );
      } else if (telPhoneType == 2) {
        this.msg = "请输入正确的电话号码，格式为“+国际区号-区号-电话号码”";
        return (/^(([0\+]\d{2,4}-?)?(0\d{2,4})-?)?(\d{7,8})(-(\d{1,}))?$/.exec(value)
        );
      } else {
        this.msg = "加上区号请输入 10 到 16 个数字";
        return (/^(\d{10,16})(-(\d{1,}))?$/.test(value)
        );
      }
    },
    msg: "加上区号请输入 10 到 16 个数字"
  },
  "en_name_addr": {
    valid: function valid(value, param) {
      if (param && param.length > 1) {
        var len = value.length;
        if (len <= param[0] || len > param[1]) {
          this.msg = "请输入 {0} 到 {1} 个字符";
          return false;
        } else {
          this.msg = "请输入正确的字符，只能包含数字，英文字母和英文特殊符号";
        }
      }
      return (/^[\x00-\xff]+$/.test(value)
      );
    },
    msg: "请输入正确的字符，只能包含数字，英文字母和英文特殊符号"
  },
  "en_name": {
    valid: function valid(value) {
      return (/^[0-9a-zA-Z,()-\.\s"\/]+$/.test(value)
      );
    },
    msg: "请输入正确的字符，只能包含英文字母，逗号，句号，括号，短横线，双引号，斜杠。"
  },
  "valFirst": {
    valid: function valid(value, param) {
      function checkfirstval(t) {
        return (/(^[\u4e00-\u9fa5a-zA-Z]+)([^\n]*)$/.test(value)
        );
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (checkfirstval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,且必须输入以字符开头"
  },

  ch_en_num_syms: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\s\*]+$/;
        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能输入负数、小数、乱码（*）、空格"
  },

  ch_en_num_sym: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*]+$/;
        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能输入负数、小数、乱码（*）"
  },

  ch_num_sym: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*A-Za-z]+$/;
        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能输入负数、小数、英文、乱码（*）"
  },

  en_num_sym: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*\u4e00-\u9fa5]+$/;

        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能输入负数、小数、中文、乱码（*）"
  },

  num_sym: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*A-Za-z\u4e00-\u9fa5]+$/;
        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能输入负数、小数、中文、英文、乱码（*）"
  },

  numex_ch_sym: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*A-Za-z]+$/;
        var regularExpression2 = /^(-[0-9\.{0,1}]+)$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能输入负数、英文、乱码（*）"
  },

  val_sym: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression = /^[^\*]+$/;
        return regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能输入乱码（*）"
  },

  en_num_addr: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression = /^.*[^\d].*$/;
        return regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能全部输入数字字符"
  },

  cn_reason: {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression = /^\w+$/;
        return !regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (checkunval(value)) {
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,不能输入纯数字纯字符"
  },

  compareBegAndCurrDate: {
    valid: function valid(value, current) {
      return current >= value;
    },
    msg: "开始日期不能大于当天"
  },

  compareEndAndCurrDate: {
    valid: function valid(value, current) {
      return value >= current;
    },
    msg: "结束日期不能小于当天"
  },

  "zintsize": {
    valid: function valid(value, param) {
      var value = _.trim(value);

      function isnumber(s) {
        var regularExpression = /^[0-9]\d*$/;
        return eval(regularExpression).test(s);
      }

      var flag = isnumber(value);
      if (!flag) {
        this.msg = "请输入正确的正整数";
        return false;
      }
      if (value >= param[0] && value <= param[1]) {
        return true;
      } else {
        this.msg = "最小值为{0}，最大值为{1}";
        return false;
      }
    },
    msg: "请输入正确的正整数"
  },
  "emailZT": {
    valid: function valid(value, param) {
      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      var len = change2star(value).length;
      if (param && param.length > 0) {
        if (len < param[0] || len > param[1]) {
          this.msg = "请输入4到32个字符，1个中文算两个字符";
        } else {
          this.msg = "请输入正确的邮箱地址";
        }
        return len <= param[1] && /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
      } else {
        return (/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value)
        );
      }
    },
    msg: "请输入正确的邮箱地址"
  },

  "telZT": {
    valid: function valid(value) {
      return (/^(([0\+]\d{2,3}-?)?(0\d{2,3})-?)?(\d{7,8})(-(\d{1,}))?$/.exec(value)
      );
    },
    msg: "请输入正确的电话号码，格式为“+国际区号-区号-电话号码”"
  },

  "mobileortel": {
    valid: function valid(value) {
      var mobileReg = /^([+]?[\d]{1,3}-|[ ])?((13[0-9]{9})|(18[0-9]{9})|(15[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(16[0-9]{9})|(19[0-9]{9}))$/;
      var telReg = /^(([0\+]\d{2,4}-?)?(0\d{2,4})-?)?(\d{7,8})(-(\d{1,}))?$/;

      if (_.indexOf([7, 8], value.length) != -1) {
        return false;
      }

      return mobileReg.test(value) || telReg.test(value);
    },
    msg: "请输入正确的手机号码或者电话号码"
  },

  "val": {
    valid: function valid(value, param) {
      if (!param) {
        param = [1, 16];
      }
      if (param.length > 2 && param[2] == "0") {
        this.msg = "请输入 {0} 到 {1}个字符,且不能输入特殊字符";
      }

      function keepchar(v, k) {
        $.each(k, function (index, val) {
          v = v.replace(k[index], " ");
        });
        return v;
      }

      function checkunval(t) {
        var regularExpression = /^[^@。，,？?【】《》<>：；\[\]{}!！+=—~|\/\'\\\"#$%&\^\*]+$/;
        return regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (checkunval(value)) {
        var len = change2star(value).length;
        !param[1] && (param = [1, param[0]]);
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符,且不能输入特殊字符(中文算两个字符)"
  },

  "zzcode": {
    valid: function valid(value, param) {
      var value = _.trim(value);

      function isnumber(s) {
        var regularExpression = /^[0-9]\d*$/;
        return eval(regularExpression).test(s);
      }
      if (value.length != 10 || value.substring(8, 9) != "-" || !isnumber(value.substring(0, 8)) || !isnumber(value.substring(9, 10))) {
        this.msg = "请输入正确的组织机构代码,格式为XXXXXXXX-X(其中X为0-9的数字)!";
        return false;
      } else {
        return true;
      }
    }
  },
  "addressZT": {
    valid: function valid(value, param) {
      function change2star(s) {
        var reg = new RegExp("不详", "g");
        return s.replace(reg, "").replace(/[^\x00-\xff]/g, "**");
      }
      var len = change2star(value).length;
      return len >= param[0] && len <= param[1];
    },
    msg: "请输入16到64个字符，1个中文算2个字符，“不详”算0个字符"
  },
  "max": {
    valid: function valid(value) {
      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      return value.length <= param;
    },
    msg: "最大长度不能超过{0}"
  },

  "valAX": {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\s\n\?\？]+$/;
        return regularExpression1.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        this.msg = "请输入 {0} 到 {1}个字符";
        return len >= param[0] && len <= param[1];
      } else {
        this.msg = "不能输入空格、换行符、问号";
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符"
  },

  "percent": {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[0-9]\d*$/;
        var regularExpression2 = new RegExp("^[0-9]\\d*\\.\\d{0," + (param && param[2] ? param[2] : "3") + "}$");
        return regularExpression1.test(t) || regularExpression2.test(t);
      }
      if (checkunval(value)) {
        if (param && param[2]) {
          this.msg = "请输入{0}到{1}的数值并且最多输入" + param[2] + "位小数";
        }
        return _Number$parseFloat(value) >= param[0] && _Number$parseFloat(value) <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入{0}到{1}的整数或三位小数"
  },

  "num_eng": {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[A-Za-z0-9]+$/;
        return regularExpression1.test(t);
      }
      if (checkunval(value)) {
        return value.length >= param[0] && value.length <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符，只能输入数字或英文字符"
  },

  "en_ch_ax": {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression = /[^\u4e00-\u9fa5a-zA-Z() （）—、·\-]+/;
        return !regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符，不允许输入数字或特殊字符"
  },

  "code_ax": {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression = /[^\u4e00-\u9fa5a-zA-Z0-9()]+/;
        return !regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    msg: "请输入 {0} 到 {1}个字符，只能输入英文或数字且不能输入除英文符号“(”“)”以外的其他字符！"
  },
  "no_num": {
    valid: function valid(value, param) {
      return !/[0-9]+$/.test(value);
    },
    msg: "不允许输入数字！"
  },
  "pur_num": {
    valid: function valid(value, param) {
      return (/[0-9]+$/.test(value)
      );
    },
    msg: "只允许输入数字！"
  },

  "code_fixed_len": {
    valid: function valid(value, param) {
      if ([param[0], param[1]].includes(value.length)) {
        return true;
      }
      return false;
    },
    msg: "请输入{0}位或{1}位的号码"
  },

  "org_busi_range": {
    valid: function valid(value, param) {
      if (!["无", "其他", "其它", "见营业执照"].includes(value)) {
        return true;
      }
      return false;
    },
    msg: "请输入详细的经营范围！"
  },
  "org_busi_range_new": {
    valid: function valid(value, param) {
      if (["无", "其他", "其它", "见营业执照"].includes(value)) {
        this.msg = "请输入详细的经营范围！";
        return false;
      }
      this.msg = "请输入 {0} 到 {1} 个字符，1个中文算2个字符";
      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      var len = change2star(value).length;
      return len >= param[0] && len <= param[1];
    },
    msg: "请输入详细的经营范围！"
  },

  "hkg_mac_ctn_cardno": {
    valid: function valid(e, t) {
      t = t || [0, 48];
      if (/[^a-zA-Z\d\(\)]+/.test(e)) return !1;
      var a = e.replace(/[^\x00-\xff]/g, "**").length;
      return a >= t[0] && a <= t[1];
    },
    msg: "最多输入48个字符，不能输入除英文符号“(”“)”以外的其他字符！" },

  "spe_en_ch": {
    valid: function valid(e, t) {
      t = t || [4, 32];
      if (/[^\u4e00-\u9fa5a-zA-Z\(\)\·\（\）\,\，\、\—\-\s]+/.test(e)) return !1;
      var a = e.replace(/[^\x00-\xff]/g, "**").length;
      return a >= t[0] && a <= t[1];
    },
    msg: "输入名称或姓名中包含特殊字符，请重新输入！"
  },

  "expire_date": {
    valid: function valid(value, param) {
      var expFlag = date.compareDate(date.formatDate(new Date(), "yyyyMMdd"), value);
      return expFlag < 1;
    },
    msg: "您的证件已过期,请完善!"
  },

  "url_address": {
    valid: function valid(value) {
      return (/^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-\(\)]*[\w@?^=%&/~+#-\(\)])?$/.test(value)
      );
    },
    msg: "请输入有效的url地址"
  },

  "num_eng_mac": {
    valid: function valid(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[A-Za-z0-9]+$/;
        return regularExpression1.test(t);
      }
      if (checkunval(value)) {
        return value.length == param[0];
      } else {
        return false;
      }
    },
    msg: "请输入2个数字或英文字符"
  },

  moneyExpand: {
    valid: function valid(value, param) {

      var value = _.trim(value);

      var newValue = value.replace(/,|，{1,}/g, "");

      function isnumber(s, p1, p2) {
        if (!param[2]) {
          var val = s.replace(/\.|。/g, "");
          if (/^0+$/ig.test(val)) {
            return false;
          }
        }
        if (!!param[3] && Number(s) > Number(param[3])) {
          return false;
        }

        var regularExpression = "/^(-)?(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$/";
        return eval(regularExpression).test(s) && /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(s);
      }

      function isnumber2(s, p1) {

        if (s.length > 1 && /^0+$/ig.test(s)) {
          return false;
        }
        if (!!param[3] && Number(s) > Number(param[3])) {
          return false;
        }
        var num = !param[2] ? 1 : 0;
        var regularExpression = "/^(-)?[" + num + "-9](\\d){0," + (parseInt(p1) - 1) + "}$/";

        return eval(regularExpression).test(s) && /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(s);
      }
      var type = !!param[3],
          errMsg = "";
      var value = _.trim(value);
      var newValue = value.replace(/,|，{1,}/g, "");
      if (type && Number(newValue) > Number(param[3])) {
        this.msg = "请输入正确的金额，金额最大数为" + param[3] + "";
      } else {
        this.msg = "请输入正确的金额，金额整数最大{0}位，小数点{1}位";
      }
      var flag = newValue.indexOf(".") != -1 ? isnumber(newValue, param[0], param[1]) : isnumber2(newValue, param[0]);
      if (!flag) {
        return false;
      } else if (newValue.indexOf(".") == newValue.length - 1) {
        return false;
      } else {
        return true;
      }
    }
  }
};

export default validateRules;


//////////////////
// WEBPACK FOOTER
// ./src/components/preEntry/validateRules.js
// module id = 164
// module chunks = 2